import { render, staticRenderFns } from "./GoogleCustomerReviewsBadge.vue?vue&type=template&id=5634c600&scoped=true"
import script from "./GoogleCustomerReviewsBadge.vue?vue&type=script&lang=js"
export * from "./GoogleCustomerReviewsBadge.vue?vue&type=script&lang=js"
import style0 from "./GoogleCustomerReviewsBadge.vue?vue&type=style&index=0&id=5634c600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634c600",
  null
  
)

export default component.exports